import { render, staticRenderFns } from "./changeBank.vue?vue&type=template&id=154aec1b&scoped=true&"
import script from "./changeBank.vue?vue&type=script&lang=js&"
export * from "./changeBank.vue?vue&type=script&lang=js&"
import style0 from "./changeBank.vue?vue&type=style&index=0&id=154aec1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154aec1b",
  null
  
)

export default component.exports